const CircleCrossIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.9999 22.7498C6.06996 22.7498 1.25 17.9299 1.25 11.9999C1.25 6.06996 6.06996 1.25 11.9999 1.25C17.9299 1.25 22.7498 6.06996 22.7498 11.9999C22.7498 17.9299 17.9299 22.7498 11.9999 22.7498ZM11.9999 2.74999C6.89996 2.74999 2.74999 6.89996 2.74999 11.9999C2.74999 17.0999 6.89996 21.2498 11.9999 21.2498C17.0999 21.2498 21.2498 17.0999 21.2498 11.9999C21.2498 6.89996 17.0999 2.74999 11.9999 2.74999Z"
				fill="currentColor"
			/>
			<path
				d="M9.16937 15.5808C8.97937 15.5808 8.78937 15.5108 8.63937 15.3608C8.34938 15.0708 8.34938 14.5908 8.63937 14.3008L14.2993 8.64084C14.5893 8.35084 15.0693 8.35084 15.3593 8.64084C15.6493 8.93084 15.6493 9.41083 15.3593 9.70083L9.69936 15.3608C9.55937 15.5108 9.35937 15.5808 9.16937 15.5808Z"
				fill="currentColor"
			/>
			<path
				d="M14.8293 15.5808C14.6393 15.5808 14.4493 15.5108 14.2993 15.3608L8.63937 9.70083C8.34938 9.41083 8.34938 8.93084 8.63937 8.64084C8.92937 8.35084 9.40937 8.35084 9.69936 8.64084L15.3593 14.3008C15.6493 14.5908 15.6493 15.0708 15.3593 15.3608C15.2093 15.5108 15.0193 15.5808 14.8293 15.5808Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default CircleCrossIcon;
